import { render, staticRenderFns } from "./RejectVisaMessage.vue?vue&type=template&id=5fe07cee"
import script from "./RejectVisaMessage.vue?vue&type=script&lang=js"
export * from "./RejectVisaMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports